var _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoAzureDevops = function SvgLogoAzureDevops(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Azure DevOps")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0078D4",
    d: "m6 19.565 3.369-4.209 12.609-4.851V7l11.057 7.653L10.447 18.8v11.678L6 29.264v-9.699Zm36-6.317v20.799L33.369 41l-13.951-4.336V41l-8.971-10.524 22.588 2.551V14.651L42 13.248Z"
  })));
};
export default SvgLogoAzureDevops;